import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import style from "../../styles/inputGrid.module.css";
import ImagenCerrar from "../../images/cerrar.png";
// import { useQuery } from "@tanstack/react-query";
import { useProducto } from "../../actions/Producto";
const FormCompra = () => {
   const hoy = new Date();
   // const [onChange, setOnChange] = useState(false);
   const token = localStorage.getItem("token");
   const urlCompra = process.env.REACT_APP_URL_DIR + "compra";
   const { GetProductos } = useProducto();
   const data = GetProductos();
   // const [nombre, setName] = useState("");
   const [ttitulo, setTtitulo] = useState("");
   //   const [data, setData] = GetProductos();
   //   var data = GetProductos();
   const location = useLocation();
   const navigate = useNavigate();
   const { state } = location;
   var totalCompra = 0;
   const [input, setInput] = useState({
      tipo: 1,
      titulo: "",
      fecha: hoy.toISOString().split("T")[0],
      id: state ? state.id : 0,
      id_primary: state ? state.id_primary : 0,
      companyId: state ? state.companyId : 0,
      total: state ? state.total : 0,
      productos: state ? state.productos : [],
      compra: [],
   });
   // const [ productos, setProductos] = useState([]);
   var productosFiltrado = [];
   var muestroProd = true;
   // const { data, isLoading } = useQuery({
   //    queryKey: ["producto"],
   //    queryFn: () =>
   //       fetch(urlProducto, {
   //          headers: {
   //             Authorization: `Bearer ${token}`,
   //          },
   //       }).then((res) => res.json(), console.log("busco datos")),
   // });

   if (data && state.id_primary === 0) {
      console.log("Grabando productosFiltrado");
      for (let i = 0; i < data.length; i++) {
         const newProdmp = {
            cod_proveedor: data[i].cod_proveedor,
            descripcion: data[i].descripcion,
            dolar: data[i].dolar,
            stock: data[i].stock,
            tipoprod: data[i].tipoprod,
            cantidad: 0,
         };
         productosFiltrado.push(newProdmp);
      }
   }

   if (input.productos?.length > 0) {
      // setName(input.titulo)
      muestroProd = false;
      console.log("Entre");
      for (let indx = 0; indx < input.productos.length; indx++) {
         console.log("cod_proveedor: ", input.productos[indx].cod_proveedor);
         const newProdmp = {
            cod_proveedor: input.productos[indx].cod_proveedor,
            descripcion: input.productos[indx].descripcion,
            precio: input.productos[indx].dolar,
            stock: input.productos[indx].stock,
            cantidad: input.productos[indx].compraproducto.cantidad,
         };
         input.compra.push(newProdmp);
      }
   }


   const handleRemove = (id) => {
      for (let x = 0; x < input.compra.length; x++) {
         console.log("handleRemove: ", input.compra[x].cod_proveedor);
         if (input.compra[x].cod_proveedor === id) {
            input.compra.splice(x, 1);
         }
      }
      setInput({ ...input, cantidad: 1 });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      input.titulo = ttitulo;
      input.total = totalCompra;
      console.log("handleSubmit : ", input);
      fetch(urlCompra, {
         method: "POST",
         body: JSON.stringify(input),
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      }).then((res) => res.json());
      input.titulo = "";
      input.total = 0;
      input.insumos = [];
      input.compra = [];
      input.productosFiltrado = [];
      window.location.href = "/Compra";
   };
   function handleNewCant(id) {
      console.log("handleNewCant: ",id);
   }

   function handleCant(e, codprv, tipo) {
      console.log("e.key: ", e.key);
      var encontre = "N";
      if (e.key === "Enter") {
         if (e.target.value > 0) {
            console.log("prod id : ", codprv, e.target.value);
            // Busco producto
            for (let x = 0; x < input.compra.length; x++) {
               if (input.compra[x].cod_proveedor === codprv) {
                  encontre = "S";
                  if (tipo === "C") {
                     input.compra[x].cantidad = e.target.value;
                  } else {
                     input.compra[x].precio = e.target.value;
                  }
               }
            }
            if (encontre === "N") {
               for (let z = 0; z < data.length; z++) {
                  if (data[z].cod_proveedor === codprv) {
                     const newProdmp = {
                        id: data[z].id,
                        cod_proveedor: data[z].cod_proveedor,
                        descripcion: data[z].descripcion,
                        dolar: data[z].dolar,
                        stock: data[z].stock,
                        cantidad: 0,
                        precio: 0,
                     };
                     if (tipo === "C") {
                        newProdmp.cantidad = e.target.value;
                     } else {
                        newProdmp.precio = e.target.value;
                     }
                     encontre = "S";
                     newProdmp.precio = newProdmp.dolar / newProdmp.cantidad;
                     console.log("newProdmp: ", newProdmp);
                     input.compra.push(newProdmp);
                  }
               }
            }
         } else {
            for (let x = 0; x < input.compra.length; x++) {
               if (input.compra[x].cod_proveedor === codprv) {
                  console.log(
                     "tipo: ",
                     tipo,
                     input.compra[x].cantidad,
                     input.compra[x].precio
                  );
                  if (tipo === "C") input.compra[x].cantidad = 0;
                  if (tipo === "P") input.compra[x].precio = 0;
                  console.log(
                     "input.compra[x].precio: ",
                     input.compra[x].precio
                  );
                  if (
                     parseInt(input.compra[x].cantidad) === 0 &&
                     parseFloat(input.compra[x].precio) === 0
                  ) {
                     console.log("splice: ");
                     input.compra.splice(x, 1);
                  }
                  encontre = "S";
               }
            }
         }
         console.log("encontre: ", encontre);
         if (encontre === "S") {
            setInput({ ...input, cantidad: 1 });
         }
         console.log("handleCant: ", productosFiltrado, input.compra);
      }
   }
   function handleCant2(e, codprv, tipo) {
      if (e.target.value > 0) {
         var encontre = "N";
         console.log("prod id : ", codprv, e.target.value);
         for (let x = 0; x < input.compra.length; x++) {
            if (input.compra[x].cod_proveedor === codprv) {
               console.log("encontre");
               encontre = "S";
               if (tipo === "C") {
                  input.compra[x].cantidad = e.target.value;
               } else {
                  input.compra[x].precio = e.target.value;
               }
            }
         }
         if (encontre === "N") {
            for (let z = 0; z < data.length; z++) {
               if (data[z].cod_proveedor === codprv) {
                  const newProdmp = {
                     id: data[z].id,
                     cod_proveedor: data[z].cod_proveedor,
                     descripcion: data[z].descripcion,
                     dolar: data[z].dolar,
                     stock: data[z].stock,
                     cantidad: 0,
                     precio: 0,
                  };
                  if (tipo === "C") {
                     newProdmp.cantidad = e.target.value;
                  } else {
                     newProdmp.precio = e.target.value;
                  }
                  encontre = "S";
                  console.log("newProdmp: ", newProdmp);
                  input.compra.push(newProdmp);
               }
            }
         }
      } else {
         for (let x = 0; x < input.compra.length; x++) {
            if (input.compra[x].cod_proveedor === codprv) {
               console.log(
                  "tipo: ",
                  tipo,
                  input.compra[x].cantidad,
                  input.compra[x].precio
               );
               if (tipo === "C") input.compra[x].cantidad = 0;
               if (tipo === "P") input.compra[x].precio = 0;
               console.log("input.compra[x].precio: ", input.compra[x].precio);
               if (
                  parseInt(input.compra[x].cantidad) === 0 &&
                  parseFloat(input.compra[x].precio) === 0
               ) {
                  console.log("splice: ");
                  input.compra.splice(x, 1);
               }
               encontre = "S";
            }
         }
      }
      console.log("encontre: ", encontre);
      if (encontre === "S") {
         setInput({ ...input, cantidad: 1 });
      }
      console.log("handleCant: ", productosFiltrado, input.compra);
   }

   console.log("input: ", input);
   console.log("input.productos: ", productosFiltrado);

   return (
      <>
         <div className={style.container}>
            <div className={style.gridTable}>
               <div>
                  <div className={style.divizq}>
                     <div className={style.trTitle}>Compras Productos</div>
                     {/* <div className={style.divBuscar}>
                        <label htmlFor="search-navbar">Buscar:&nbsp;</label>
                        <input
                           className={style.inputBuscar}
                           onChange={(e) => setName(e.target.value)}
                           type="text"
                           id="search-navbar"
                           placeholder="Buscar..."
                           value={nombre}
                        />
                     </div>
                     <div className={style.divBuscar}>
                        <label htmlFor="search-navbar">
                           Descripcion:&nbsp;
                        </label>
                        <input
                           className={style.inputBuscar}
                           type="text"
                           id="search-navbar"
                           placeholder="Descripcion de la compra"
                           value={ttitulo}
                           onChange={(e) => setTtitulo(e.target.value)}
                        />
                     </div> */}
                     <div className={style.divflex}>
                        <div
                           className={
                              muestroProd ? style.divizq : style.divHide
                           }
                        >
                           <table className={style.gridTable}>
                              <thead>
                                 <tr className={style.trTitle}>
                                    <th>ID</th>
                                    <th>Decripcion</th>
                                    <th>Precio</th>
                                    <th>Stock Actual</th>
                                    <th>Cantidad de Unidades</th>
                                    <th>Precio</th>
                                 </tr>
                              </thead>
                              {productosFiltrado &&
                                 productosFiltrado.map((serv, indx) => {
                                    var muestroreg = true;
                                    // if (nombre !== "") {
                                    //    if (
                                    //       serv.descripcion
                                    //          .toUpperCase()
                                    //          .includes(nombre.toUpperCase())
                                    //    ) {
                                    //       muestroreg = true;
                                    //    } else {
                                    //       muestroreg = false;
                                    //    }
                                    // }
                                    if (serv.tipoprod > 1) {
                                       muestroreg = false;
                                    }
                                    if (muestroreg) {
                                       return (
                                          <tr
                                             key={indx}
                                             onClick={() =>
                                                handleNewCant(serv.id)
                                             }
                                          >
                                             <td className={style.tdleft}>
                                                {serv.cod_proveedor}
                                             </td>
                                             <td className={style.tdleft}>
                                                {serv.descripcion}
                                             </td>
                                             <td className={style.precio}>
                                                {serv.dolar}
                                             </td>
                                             <td className={style.precio}>
                                                {serv.stock}
                                             </td>
                                             <td className={style.tdright}>
                                                &nbsp;&nbsp;&nbsp;
                                                <input
                                                   className={style.style_input}
                                                   type="text"
                                                   // value={serv.cantidad}
                                                   onBlur={(e) =>
                                                      handleCant2(
                                                         e,
                                                         serv.cod_proveedor,
                                                         "C"
                                                      )
                                                   }
                                                   onKeyPress={(e) =>
                                                      handleCant(
                                                         e,
                                                         serv.cod_proveedor,
                                                         "C"
                                                      )
                                                   }
                                                ></input>
                                             </td>
                                             <td className={style.tdright}>
                                                &nbsp;&nbsp;&nbsp;
                                                <input
                                                   className={style.style_input}
                                                   type="text"
                                                   // value={serv.cantidad}
                                                   onBlur={(e) =>
                                                      handleCant2(
                                                         e,
                                                         serv.cod_proveedor,
                                                         "P"
                                                      )
                                                   }
                                                   onKeyPress={(e) =>
                                                      handleCant(
                                                         e,
                                                         serv.cod_proveedor,
                                                         "P"
                                                      )
                                                   }
                                                ></input>
                                             </td>
                                          </tr>
                                       );
                                    } else {
                                       return null;
                                    }
                                 })}
                           </table>
                        </div>
                        <div className={style.divright}>
                           <table className={style.gridTable}>
                              <thead>
                                 <tr className={style.trTitle}>
                                    <th>ID</th>
                                    <th>Decripcion</th>
                                    {/* <th>Stock Actual</th> */}
                                    <th>Cantidad</th>
                                    <th>Precio</th>
                                    <th>##</th>
                                 </tr>
                              </thead>
                              {input.compra &&
                                 input.compra.map((serv) => {
                                    totalCompra += parseFloat(serv.precio);
                                    return (
                                       <tr
                                          key={serv.id}
                                          onClick={() => handleNewCant(serv.id)}
                                       >
                                          <td className={style.tdleft}>
                                             {serv.cod_proveedor}
                                          </td>
                                          <td className={style.tdleft}>
                                             {serv.descripcion}
                                          </td>
                                          {/* <td className={style.precio}>
                                             {serv.stock}
                                          </td> */}
                                          <td className={style.precio}>
                                             &nbsp;&nbsp;&nbsp;{serv.cantidad}
                                             &nbsp;
                                          </td>
                                          <td className={style.precio}>
                                             &nbsp;&nbsp;&nbsp;{serv.precio}
                                             &nbsp;&nbsp;&nbsp;
                                          </td>
                                          <td>
                                             <img
                                                onClick={() =>
                                                   handleRemove(
                                                      serv.cod_proveedor
                                                   )
                                                }
                                                src={ImagenCerrar}
                                                height="30px"
                                                alt=""
                                             />
                                          </td>
                                       </tr>
                                    );
                                 })}
                              <tr>
                                 <td colSpan={3}>Total Compra :&nbsp;</td>
                                 <td className={style.trTitle}>
                                    {totalCompra.toFixed(2)}
                                 </td>
                              </tr>
                     <tr>
                        <td>Descripcion</td>
                        <td colSpan={5}>
                              <input
                                 className={style.inputDescripcion}
                                 type="text"
                                 placeholder="Titulo de la compra"
                                 value={ttitulo}
                                 onChange={(e) => setTtitulo(e.target.value)}
                              />
                        </td>
                     </tr>          
                     <tr>
                              {muestroProd ? (
                                 <td colSpan={2}>
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={(e) => handleSubmit(e)}
                                    >
                                       {" "}
                                       Grabar
                                    </button>
                                 </td>
                                 ):(null)
                              }                    
                                 <td colSpan={3}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => {
                                          navigate("/Compra");
                                       }}
                                    >
                                       VOLVER
                                    </button>
                                 </td>
                              </tr>
                           </table>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default FormCompra;
